require('./shared/helpers');
require('./shared/constants');
require('./shared/validations');
require('./shared/binding-handlers');
var App = require('./app-checkin/app');

global.bookedby = global.bookedby || {};

console.log(bookedby.deps);

$(document).ready(function(){
  global.bookedby.app = new App();
  global.bookedby.routes = require('./app/routes');
  global.bookedby.app.init();
});